import { startTransition } from 'react';
import { Link } from 'react-router';

import { EscrowStatusEnum } from 'src/graphql/schema';

import { useEscrowDashboardCard } from '../model/context';

const ContentWrapper = ({ children }: React.PropsWithChildren) => {
  const { viewModel, config } = useEscrowDashboardCard();
  const { id, invitationId, status } = viewModel;
  const { basePath, onInvitationClick } = config;

  const handleClick = () => startTransition(() => onInvitationClick(invitationId!));
  const url = status === EscrowStatusEnum.Draft ? `${basePath}/onboarding/${id}` : `${basePath}/${id}`;

  if (invitationId)
    return (
      <div onClick={handleClick} className="cursor-pointer">
        {children}
      </div>
    );

  return <Link to={url}>{children}</Link>;
};

export { ContentWrapper };
